import {
  asIsoDate,
  guessDateFormats,
  isIsoDate,
  supportedDateFormats,
  userInputToIsoDate,
} from 'components/shared/DatePicker/utils';

const csvFormat = ['dd-MMM-yy'];
const supportedDateFormatsList = supportedDateFormats(...csvFormat);

export function toDateString(value?: unknown): string | undefined {
  if (value instanceof Date) {
    return asIsoDate(value);
  }

  if (typeof value !== 'string') {
    return undefined;
  }

  const trimmed = value.trim();
  if (isIsoDate(trimmed)) {
    return trimmed;
  }

  const matchingFormats = guessDateFormats([trimmed], supportedDateFormatsList);

  for (const format of matchingFormats) {
    const isoDate = userInputToIsoDate(trimmed, format);
    if (isoDate) {
      return isoDate;
    }
  }

  return undefined;
}
